import { RouteConfig } from "vue-router";

import { getQueryStringValue } from "../helpers";

const DefaultRoute: RouteConfig = {
    path: "/",
    beforeEnter: () => {
        if (process.env.NODE_ENV === "production") {
            window.location.href = "http://everbrightmedia.com";
        }
    }
};

const Step2Route: RouteConfig = {
    // NOTE: Step 2 must be defined BEFORE step 1, or else it will think step-2 is a slug.
    path: "/:slug/step-2",
    name: "step-2",
    component: () =>
        import(
            /* webpackChunkName: "view-[request]" */ "../views/CheckoutStep2.vue"
        ),
    props: route => ({
        promotionSlug: route.params.slug
    })
};

const ThankYouRoute: RouteConfig = {
    path: "/:slug/thank-you/:orderId",
    name: "thankyou",
    component: () =>
        import(
            /* webpackChunkName: "view-[request]" */ "../views/ThankYou.vue"
        ),
    props: route => ({
        promotionSlug: route.params.slug,
        orderId: route.params.orderId
    })
};

const Step1Route: RouteConfig = {
    path: "/:slug",
    name: "step-1",
    component: () =>
        import(
            /* webpackChunkName: "view-[request]" */ "../views/CheckoutStep1.vue"
        ),
    props: route => ({
        promotionSlug: route.params.slug,
        promotionCode: getQueryStringValue(
            route.query as Record<string, string>,
            "promotionCode"
        )
    })
};

const routes: RouteConfig[] = [
    Step2Route,
    ThankYouRoute,
    Step1Route,
    DefaultRoute
];

export default routes;

export { Step1Route, Step2Route, ThankYouRoute };
